import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Tag
} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import LibraryForm from "./library_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";


const LibraryTable = ({
    rowKey = "",
    keyPrefix = "koha.library",
    showAllColumns = true,
    propsShowColumns,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { },//selectInfo
    permission_level = null,
    apiRoute = "/koha/library",
    onSelect = () => { },
    toolBarRender = (tools) => ([...tools]),
    customFormItems = () => { }, //上層可加入自定義的form item 
    customColumns = [], //列表編輯模式的顯示columns
    readonly = false,
    propsShowKeys = [
        { key: "staff_serial_name", name: "staff_serial_name", hidden: false, require: false },
    ],
    propsPatchProcess = () => { },
    propsInitialValues = {},
    propsSearchParams,
    onSearchParamsChange = () => { },
    searchParamsChangeToSearch = true
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    const columns = [
        {
            title: t("branchcode"),
            key: "branchcode",
            dataIndex: "branchcode",
            align: "center",
        },
        {
            title: t("branchname"),
            key: "branchname",
            dataIndex: "branchname",
            align: "center",
        },
        {
            title: t("branchaddress1"),
            key: "branchaddress1",
            dataIndex: "branchaddress1",
            align: "center",
        },
        // {
        //     title: t("branchaddress2"),
        //     key: "branchaddress2",
        //     dataIndex: "branchaddress2",
        //     align: "center",
        // },
        // {
        //     title: t("branchaddress3"),
        //     key: "branchaddress3",
        //     dataIndex: "branchaddress3",
        //     align: "center",
        // },
        // {
        //     title: t("branchzip"),
        //     key: "branchzip",
        //     dataIndex: "branchzip",
        //     align: "center",
        // },
        {
            title: t("branchcity"),
            key: "branchcity",
            dataIndex: "branchcity",
            align: "center",
        },
        {
            title: t("branchstate"),
            key: "branchstate",
            dataIndex: "branchstate",
            align: "center",
        },
        {
            title: t("branchcountry"),
            key: "branchcountry",
            dataIndex: "branchcountry",
            align: "center",
        },
        {
            title: t("branchphone"),
            key: "branchphone",
            dataIndex: "branchphone",
            align: "center",
        },
        {
            title: t("branchfax"),
            key: "branchfax",
            dataIndex: "branchfax",
            align: "center",
        },
        {
            title: t("branchemail"),
            key: "branchemail",
            dataIndex: "branchemail",
            align: "center",
        },
        {
            title: t("branchillemail"),
            key: "branchillemail",
            dataIndex: "branchillemail",
            align: "center",
        },
        {
            title: t("branchreplyto"),
            key: "branchreplyto",
            dataIndex: "branchreplyto",
            align: "center",
        },
        {
            title: t("branchreturnpath"),
            key: "branchreturnpath",
            dataIndex: "branchreturnpath",
            align: "center",
        },
        // {
        //     title: t("branchurl"),
        //     key: "branchurl",
        //     dataIndex: "branchurl",
        //     align: "center",
        // },
        // {
        //     title: t("issuing"),
        //     key: "issuing",
        //     dataIndex: "issuing",
        //     align: "center",
        // },
        {
            title: t("branchip"),
            key: "branchip",
            dataIndex: "branchip",
            align: "center",
        },
        {
            title: t("branchnotes"),
            key: "branchnotes",
            dataIndex: "branchnotes",
            align: "center",
        },
        ...customColumns,

        // {
        //     title: t("geolocation"),
        //     key: "geolocation",
        //     dataIndex: "geolocation",
        //     align: "center",
        // },
        // 非必要顯示欄位
        // {
        //     title: t("marcorgcode"),
        //     key: "marcorgcode",
        //     dataIndex: "marcorgcode",
        //     align: "center",
        // },
        // 非必要顯示欄位
        // {
        //     title: t("pickup_location"),
        //     key: "pickup_location",
        //     dataIndex: "pickup_location",
        //     align: "center",
        //     render: (text, record, index) => {
        //         return <Tag>{!!text ? t('yes') : t('no')}</Tag>
        //     }
        // },
        // 非必要顯示欄位
        // {
        //     title: t("public"),
        //     key: "public",
        //     dataIndex: "public",
        //     align: "center",
        //     render: (text, record, index) => {
        //         return <Tag>{!!text ? t('yes') : t('no')}</Tag>
        //     }
        // },
        // {
        // 非必要顯示欄位
        //     title: t("opacuserjs"),
        //     key: "opacuserjs",
        //     dataIndex: "opacuserjs",
        //     align: "center",
        // },
        // {
        //     title: t("opacusercss"),
        //     key: "opacusercss",
        //     dataIndex: "opacusercss",
        //     align: "center",
        // },

    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : [])

    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();
    function convertKeys(oldData) {
        const keyMapping = {
            "branchcode": "branchcode",
            "branchname": "branchname",
            "branchaddress1": "address1",
            "branchaddress2": "address2",
            "branchaddress3": "address3",
            "branchzip": "postal_code",
            "branchcity": "city",
            "branchstate": "state",
            "branchcountry": "country",
            "branchphone": "phone",
            "branchfax": "fax",
            "branchemail": "email",
            "branchillemail": "illemail",
            "branchreplyto": "reply_to_email",
            "branchreturnpath": "return_path_email",
            "branchurl": "url",
            "branchip": "ip",
            "branchnotes": "notes",
            "pickup_location": "pickup_location",
            "public": "public"
        };

        const newData = {};
        for (const oldKey in oldData) {
            if (oldData.hasOwnProperty(oldKey)) {
                const newKey = keyMapping[oldKey] || oldKey;
                newData[newKey] = oldData[oldKey];
            }
        }
        return newData;
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }

    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const LibraryController = useCRUDController({
        apiRoute: apiRoute,
        onFinish,
        onBefore
    })
    useEffect(() => {
        checkAll();
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    return (<Row>
        <Col span={24}>
            <ProTableOt
                initialValues={{
                    ...propsInitialValues
                }}
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {

                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return LibraryController.getData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }

                propsPatchProcess={(data) => {
                    return {
                        ...data,
                        axiosMode: "patch"
                    }
                }}
                propsUseData={() => {
                    return {
                        postData: (formData) => {
                            let postData = formData.map((formValue) => {
                                return convertKeys(formValue)
                            })

                            LibraryController.postData(postData)
                        },
                        patchData: (formData) => {
                            let patchData = formData.map((formValue) => {
                                return convertKeys(formValue)
                            })
                            LibraryController.patchData(patchData)
                        },
                        deleteData: LibraryController.deleteData
                    }
                }}
                PropsPatchForm={<LibraryForm
                    customFormItems={customFormItems}
                />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={permission_level === 1 ? true : false}
                propsDelete={permission_level === 1 ? true : false}
                propsPost={permission_level === 1 ? true : false}
                propsWidth={1400}
                scroll={{
                    x: "100%",
                }}
                toolBarRender={() => toolBarRender([ ])}
            />
        </Col>
    </Row>)

}
const Library = ({
    keyPrefix = "koha.library",
    permission_level = null,
    apiRoute = "/koha/library",
    // apiRoute="/cataloging/backend/library",
    onSelect = () => { },
    toolBarRender = (tools) => ([...tools]),
    customFormItems = () => { }, //上層可加入自定義的form item 
    customColumns = [], //列表編輯模式的顯示columns
    defaultSelectedKeys = [],
    defaultSelectedInfo = [],
    readonly = false,
    propsShowKeys = [
        { key: "staff_serial_name", name: "staff_serial_name", hidden: false, require: false },
    ],
    propsPatchProcess = () => { },
    propsInitialValues = {},
    propsSearchParams,
    onSearchParamsChange = () => { },
    searchParamsChangeToSearch = true
}) => {
    return (
        <Row
            gutter={[10, 20]}
        >
            <Col span={24}>
                <LibraryTable
                    keyPrefix={keyPrefix}
                    permission_level={permission_level}
                    apiRoute={apiRoute}
                    customColumns
                    customFormItems={customFormItems}
                />
            </Col>
        </Row>
    );
};
export { LibraryTable }
export default Library;

